import { z } from 'zod';

export const PositionUpdatedEventPayloadSchema = z.object({ positionId: z.string().uuid() });

export type PositionUpdatedEventPayload = z.infer<typeof PositionUpdatedEventPayloadSchema>;
